export default __webpack_public_path__ + "static/media/noun-warning-black.2a784160.svg";